import {TaskManagerService} from '../../services/task-manager.service';
import {ActivatedRoute, Router} from '@angular/router';
import {DialogService} from '@shared/services/dialog-service';
import { MatDialog } from '@angular/material/dialog';
import {Store} from '@ngrx/store';
import {TaskManagerState} from '../../store/task-manager.reducer';
import { Location } from '@angular/common';
import {Component} from '@angular/core';
import {TaskManagerTicketListComponent} from './task-manager-ticket-list.component';
import {CommandService} from "@core/services/command.service";
import {SnackBarService} from "@core/services/snack-bar.service";
@Component({
    standalone: false,
    selector: 'particle-task-manager-personal-list',
  templateUrl: './task-manager-ticket-list.component.html',
  styleUrls: ['./task-manager-ticket-list.component.scss']
})
export class TaskManagerPersonalListComponent extends TaskManagerTicketListComponent {
  constructor(protected activatedRoute: ActivatedRoute,
              protected taskManagerStore: Store<TaskManagerState>,
              public dialog: MatDialog,
              protected dialogService: DialogService,
              protected location: Location,
              protected route: Router,
              protected taskManagerService: TaskManagerService,
              protected commandService: CommandService,
              protected snackbarService: SnackBarService) {
    super(activatedRoute, taskManagerStore, dialog, dialogService, location, route, taskManagerService, commandService, snackbarService);

  }
  protected getBoardUrl(selectedBoard) {
    return `task-manager/personal/${this.getTypeView()}/${selectedBoard.id}`;
  }
  public showBoardView () {
    this.route.navigateByUrl(`task-manager/personal/card/${this.selectedBoard.id}`);
  }
  public showGridView () {
    this.route.navigateByUrl(`task-manager/personal/grid/${this.selectedBoard.id}`);
  }
}
